export default function MenuCloseIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="eoicn-close">
            <path d="M19 19L5 5"></path>
            <path d="M5 19L19 5"></path>
        </svg>
    )
}